import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
  HealthcareProviderInformationClient,
  HealthcareProviderInformationResponse,
} from 'requests/nswag/nll/NLLClient';

async function getNllHealthcareProviderInformation(customerId: string) {
  const healthCareProviderClient = new HealthcareProviderInformationClient();
  return await healthCareProviderClient.getHealthcareProviderInformation(customerId);
}

export function useFetchHealthcareProviderInformation(
  customerId: string,
): UseQueryResult<HealthcareProviderInformationResponse> {
  return useQuery({
    queryKey: ['NllCustomer', customerId],
    queryFn: () => getNllHealthcareProviderInformation(customerId),
  });
}
